import { createReducer, on } from '@ngrx/store';

import { RefundsState, RefundsStatus } from '../../interfaces/store.interface';
import * as RefundsActions from '../actions/refunds.actions';

export const initialState: RefundsState = Object.seal({ refunds: [], status: RefundsStatus.INITIAL });

const refundsReducer = createReducer(
  initialState,
  on(RefundsActions.setRefunds, (state, { refunds, status }) => ({
    ...state,
    refunds: [...refunds],
    status: status,
  })),
  on(RefundsActions.resetRefunds, () => initialState)
);

export function reducer(state: RefundsState, action: RefundsActions.RefundsActionsUnion): RefundsState {
  return refundsReducer(state, action);
}
